
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AtlasSetup extends Vue {
  get atlasSetupUrl(): string {
    return 'https://subscriber-margin-forty-spectacular.trycloudflare.com/setup';
  }
}
